export enum ComposeScenario {
    Mail = 0,
    CalendarFull = 1,
}
